
export function AboutSection() {
  return (
    <div className="pt-4 border-t border-app-border">
      <h3 className="text-lg font-semibold text-app-text-primary mb-2">
        About Grace Awakens
      </h3>
      <p className="text-sm text-app-text-secondary">
        Version 1.2.1
      </p>
    </div>
  );
}
